export enum SystemBalanceTypeEnum {
    Inlet = 1,
    Outlet = 2,
    Other = 3
} // end enum SystemBalanceTypeEnum
